import { Dtos } from "@inrev/common";

export const createAccountIndemnityAgreementDtoSchema =
	Dtos.IndemnityAgreement.Create.Request.schema;
